/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { t } from '../../providers';
import ActionButton from '../ActionButton';
import ApplicationsTableHeader from './ApplicationsTableHeader';

const useStyles = makeStyles((_theme) => ({
    actions: {
        '& .MuiButtonBase-root': {
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        width: '3%',
    },
    tableContainer: {
        minHeight: '109px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '@media (max-width:960px)': {
            width: 'calc(100vw - 60px)',
        },
    },
    imageCell: {
        textAlign: 'center',
        height: '40px',
    },
    normalCell: {
        maxWidth: '200px',
    },
    tableBody: {
        backgroundColor: '#ffffff',
    },
    rowStyle: {
        fontSize: '0.75rem',
        color: '#5D5D5D',
        fontWeight: '400',
        fontStyle: 'normal',
        LineHeight: '15.96px',
        wordBreak: 'break-all',
    },
    tableStyle: {},
    noOverflowX: {
        overflowX: 'hidden',
    },
}));

const ApplicationsTable = ({
    sortBy,
    sortType,
    setSorting,
    applications,
    tableId = 'applicationsTable',
    noContenMessage = 'no.applications',
    tableAriaLabel = '',
}) => {
    const classes = useStyles();
    const isTablet = useMediaQuery('(max-width:960px)');

    const tableHead = (
        <ApplicationsTableHeader setSorting={setSorting} sortBy={sortBy} sortType={sortType} headers={applications.headers || []} tableId={tableId} />
    );

    return (
        <TableContainer
            className={applications && applications.data && !!applications.data.length ? classes.tableContainer : classes.noOverflowX}
            style={{
                boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px rgb(0 0 0 / 14%), 0px 1px 3px rgb(0 0 0 / 12%)',
                borderRadius: '3px',
                background: '#D9D9D9',
            }}>
            <Grid item xs={12}>
                {applications && applications.headers && applications.headers.length > 0 && (
                    <Table tabIndex={0} id={`table-${tableId}`} className={(classes.table, classes.tableStyle)} aria-label={tableAriaLabel}>
                        {tableHead}
                        <TableBody className={classes.tableBody}>
                            {(!applications.data || applications.data.length === 0) && (
                                <TableRow className={classes.row}>
                                    <TableCell colSpan={applications.headers.length} align={isTablet ? 'left' : 'center'}>
                                        {t(noContenMessage)}
                                    </TableCell>
                                </TableRow>
                            )}
                            {(applications.data || []).map((app, appIdx) => (
                                <TableRow key={appIdx}>
                                    {app.map((item, idx) => {
                                        const cellClass = item.label === 'graphicalRepresentation' ? classes.imageCell : '';
                                        return (
                                            <React.Fragment key={idx}>
                                                {item.label === 'menuItems' ? (
                                                    <TableCell className={classes.actions} align="left">
                                                        <ActionButton
                                                            actionButtonId={`${tableId}-table-actionButton-${app[1].value}`}
                                                            menuItems={item.value}
                                                            appId={idx}
                                                            requestNumber={app[1].value}
                                                        />
                                                    </TableCell>
                                                ) : (
                                                    <TableCell
                                                        align="left"
                                                        className={(cellClass, classes.rowStyle)}
                                                        style={item && item.style ? item.style : {}}>
                                                        {item.value}
                                                    </TableCell>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </Grid>
        </TableContainer>
    );
};

export default ApplicationsTable;
